import React, {useEffect} from 'react'
import {Card, CardBody, CardHeader} from 'reactstrap'
import { Trans } from "react-i18next"
import {generateBarLineChart} from '../../utils/graphs_facility'
import DivergentStackedBars from '../DivergentStackedBars'
export default ({getExpositionsScores, expositions_scores }) => {

    useEffect(() => {
	getExpositionsScores()
    }, [])
    
  

  return (	    
	        <Card>
		        <CardHeader><h2>Distribuzione esposizioni e scaduti per classi di rating</h2></CardHeader>
		        <CardBody>
		          <DivergentStackedBars data={expositions_scores} name="ratingsExpositions" />
		        </CardBody>
	        </Card>
  ) 
}
